/**
 * Mijn profiel, binnen de werkplek (sessie 46, B10).
 *
 * Tot 23-09 opende "Mijn profiel" het oude portaal. Hier staat wat JP
 * dagelijks nodig heeft: naam, e-mail, rol, profielfoto en
 * pushmeldingen. De onderdelen zelf zijn die van het oude scherm
 * (`AvatarUpload`, `PushMeldingen`), niet nagebouwd: één plek waar een
 * foto of een pushabonnement wordt opgeslagen.
 *
 * Wachtwoord, tweestapsverificatie en de e-mailhandtekening blijven op
 * het oude profielscherm. Die raken beveiliging en het uitgaande
 * mailpad; die verhuizen alleen met een eigen besluit. Er staat een link
 * naartoe, met de reden erbij.
 */
import { AvatarUpload } from "@/components/profiel/AvatarUpload";
import { PushApparaten } from "@/components/profiel/PushApparaten";
import { PushMeldingen } from "@/components/profiel/PushMeldingen";
import { useAuthStore } from "@/lib/auth-store";

import { MetCopiloot } from "./Copiloot/MetCopiloot";
import { rolLabel } from "./WerkplekProfiel";

export function WerkplekMijnProfiel() {
  const gebruiker = useAuthStore((s) => s.gebruiker);
  return (
    <>
      <div className="wp-bovenbalk">
        <h1 style={{ fontSize: 17, margin: 0, fontWeight: 600 }}>Mijn profiel</h1>
      </div>
      <div className="wp-inhoud">
        <MetCopiloot pagina="profiel">
          <div
            style={{ overflowY: "auto", padding: 18, maxWidth: 820 }}
            data-mijn-profiel
          >
            {!gebruiker ? (
              <p style={{ color: "var(--wp-tekst2)" }}>Bezig met laden…</p>
            ) : (
              <>
                <section className="wp-blok">
                  <div className="wp-blok-body">
                    <dl className="wp-profiel-feiten">
                      <dt>Naam</dt>
                      <dd>{gebruiker.naam}</dd>
                      <dt>E-mail</dt>
                      <dd>{gebruiker.email}</dd>
                      <dt>Rol</dt>
                      <dd>{rolLabel(gebruiker.rol)}</dd>
                    </dl>
                  </div>
                </section>

                <section className="wp-blok">
                  <h4>Profielfoto</h4>
                  <div className="wp-blok-body">
                    <AvatarUpload gebruiker={gebruiker} />
                  </div>
                </section>

                <section className="wp-blok">
                  <h4>Pushmeldingen</h4>
                  <div className="wp-blok-body">
                    <PushMeldingen />
                  </div>
                </section>

                <section className="wp-blok">
                  <h4>Apparaten met pushmeldingen</h4>
                  <div className="wp-blok-body">
                    <PushApparaten />
                  </div>
                </section>

                <p style={{ color: "var(--wp-tekst2)", fontSize: 13 }}>
                  Wachtwoord, tweestapsverificatie en je e-mailhandtekening
                  staan op{" "}
                  <a href="/profiel/beveiliging">Beveiliging en handtekening</a>.
                </p>
              </>
            )}
          </div>
        </MetCopiloot>
      </div>
    </>
  );
}
